module.exports = __webpack_public_path__ + "static/media/bitbucket.6c55330a.png";